export var TypeActionRanking;
(function (TypeActionRanking) {
    TypeActionRanking["PlayerXpRankingRequest"] = "Rank > PlayerXpRankingRequest";
    TypeActionRanking["PlayerXpHighSocresNameRequest"] = "Rank > PlayerXpHighSocresNameRequest";
    TypeActionRanking["PlayerXpHighSocresPositionRequest"] = "Rank > PlayerXpHighSocresPositionRequest";
    TypeActionRanking["PlayerXpHighSocresReceived"] = "Rank > PlayerXpHighScoresReceived";
    TypeActionRanking["PlayerXpSelfScoreReceived"] = "Rank > PlayerXpSelfScoreReceived";
    TypeActionRanking["ClearPlayerXpHighScores"] = "Rank > ClearPlayerXpHighScores";
    TypeActionRanking["CoopXpRankingRequest"] = "Rank > CoopXpRankingRequest";
    TypeActionRanking["CoopXpHighSocresNameRequest"] = "Rank > CoopXpHighSocresNameRequest";
    TypeActionRanking["CoopXpHighSocresPositionRequest"] = "Rank > CoopXpHighSocresPositionRequest";
    TypeActionRanking["CoopXpHighSocresReceived"] = "Rank > CoopXpHighScoresReceived";
    TypeActionRanking["CoopXpSelfScoreReceived"] = "Rank > CoopXpSelfScoreReceived";
    TypeActionRanking["ClearCoopXpHighScores"] = "Rank > ClearCoopXpHighScores";
    TypeActionRanking["LanguageFilterSelected"] = "Rank > LanguageFilterSelected";
})(TypeActionRanking || (TypeActionRanking = {}));
export var actionPlayerXpRankRequest = function (nameSearch, position) { return ({
    nameSearch: nameSearch,
    position: position,
    type: TypeActionRanking.PlayerXpRankingRequest,
}); };
export var actionLanguageFilterSelected = function (selectedLanguage) { return ({
    selectedLanguage: selectedLanguage,
    type: TypeActionRanking.LanguageFilterSelected,
}); };
export var actionPlayerXpHighscoresReceived = function (highScores) { return ({
    highScores: highScores,
    type: TypeActionRanking.PlayerXpHighSocresReceived,
}); };
export var actionPlayerXpSelfScoreReceived = function (selfScore) { return ({
    selfScore: selfScore,
    type: TypeActionRanking.PlayerXpSelfScoreReceived,
}); };
export var actionPlayerXpHighScoresNameRequest = function (nameSearch) { return ({
    nameSearch: nameSearch,
    type: TypeActionRanking.PlayerXpHighSocresNameRequest,
}); };
export var actionPlayerXpHighScoresPositionRequest = function (position) { return ({
    position: position,
    type: TypeActionRanking.PlayerXpHighSocresPositionRequest,
}); };
export var actionPlayerXpClearHighScores = function () { return ({
    type: TypeActionRanking.ClearPlayerXpHighScores,
}); };
export var actionCoopXpRankRequest = function (nameSearch, position) { return ({
    nameSearch: nameSearch,
    position: position,
    type: TypeActionRanking.CoopXpRankingRequest,
}); };
export var actionCoopXpHighscoresReceived = function (highScores) { return ({
    highScores: highScores,
    type: TypeActionRanking.CoopXpHighSocresReceived,
}); };
export var actionCoopXpSelfScoreReceived = function (selfScore) { return ({
    selfScore: selfScore,
    type: TypeActionRanking.CoopXpSelfScoreReceived,
}); };
export var actionCoopXpHighScoresNameRequest = function (nameSearch) { return ({
    nameSearch: nameSearch,
    type: TypeActionRanking.CoopXpHighSocresNameRequest,
}); };
export var actionCoopXpHighScoresPositionRequest = function (position) { return ({
    position: position,
    type: TypeActionRanking.CoopXpHighSocresPositionRequest,
}); };
export var actionCoopXpClearHighScores = function () { return ({
    type: TypeActionRanking.ClearCoopXpHighScores,
}); };
export var actionRankingLanguageFilterSelected = function (selectedLanguage) { return ({
    selectedLanguage: selectedLanguage,
    type: TypeActionRanking.LanguageFilterSelected,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/ranking/actionRanking.ts
// module id = 182
// module chunks = 3